function stateConstructor(dependencyHash) {
  return {
    sessionUser: {},
  };
}

export default stateConstructor;
